"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BusinessHours',
  props: {
    shopData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      weekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      tableData: [],
      // 用于映射星期几到数字（1-7）
      weekMap: ['1', '2', '3', '4', '5', '6', '7'],
      // 业务类型启用状态
      isTs: true,
      // 堂食启用
      isWm: true,
      // 外卖启用
      isZt: true // 自提启用
    };
  },
  created: function created() {
    this.initTableData();
  },
  methods: {
    initTableData: function initTableData() {
      var _this = this;
      // 初始化业务类型启用状态，从 shopData 中读取
      if (this.shopData) {
        this.isTs = this.shopData.isTs !== undefined ? this.shopData.isTs : true;
        this.isWm = this.shopData.isWm !== undefined ? this.shopData.isWm : true;
        this.isZt = this.shopData.isZt !== undefined ? this.shopData.isZt : true;
      }

      // 尝试从 shopData 中解析已有的营业时间配置
      var servTimeMap = {};
      if (this.shopData && this.shopData.servTime) {
        try {
          var servTimeArray = JSON.parse(this.shopData.servTime);
          // 将数组转换为以星期为键的对象
          // 格式: [{"ts":{...},"zt":{...},"ws":{...},"week":"1"}, ...]
          servTimeArray.forEach(function (item) {
            servTimeMap[item.week] = item;
          });
        } catch (e) {
          console.error('解析营业时间数据失败:', e);
        }
      }

      // 初始化表格数据，包括7天的营业时间设置
      this.tableData = this.weekDays.map(function (day, index) {
        // 根据索引映射到对应的星期数字（1-7）
        var dayNum = _this.weekMap[index];
        // 获取该星期的已有配置，如果没有则使用默认值
        var existingConfig = servTimeMap[dayNum] || {};
        return {
          day: day,
          dayNum: dayNum,
          // 保存数字表示的星期几
          ts: existingConfig.ts || {
            start_time: '09:00',
            end_time: '21:00'
          },
          // 堂食时间
          zt: existingConfig.zt || {
            start_time: '09:00',
            end_time: '21:00'
          },
          // 自提时间
          ws: existingConfig.ws || {
            start_time: '09:00',
            end_time: '21:00'
          } // 外卖时间
        };
      });
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      // 将表格数据转换为要求的格式（数组格式，每项包含week字段）
      var result = [];
      this.tableData.forEach(function (row, index) {
        var dayNum = _this2.weekMap[index]; // 星期数字（1-7）
        result.push({
          ts: {
            start_time: row.ts.start_time,
            end_time: row.ts.end_time
          },
          zt: {
            start_time: row.zt.start_time,
            end_time: row.zt.end_time
          },
          ws: {
            start_time: row.ws.start_time,
            end_time: row.ws.end_time
          },
          week: dayNum
        });
      });

      // 触发提交事件，传递格式化的数据
      this.$emit('submit', {
        storeId: this.shopData.storeId,
        serv_time: JSON.stringify(result),
        isTs: this.isTs,
        // 堂食启用状态
        isZt: this.isZt,
        // 自提启用状态
        isWm: this.isWm // 外卖启用状态
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};